import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContentBadgeComponent } from './content-badge.component';
import { PlusTagComponent } from './plus-tag/plus-tag.component';
import { PlusLockedComponent } from './plus-locked/plus-locked.component';
import { PlusUnlockedComponent } from './plus-unlocked/plus-unlocked.component';
import { FullEpisodeTagComponent } from './full-episode-tag/full-episode-tag.component';
import { ArticleTagComponent } from './article-tag/article-tag.component';
import { ClipTagComponent } from './clip-tag/clip-tag.component';
import { PodcastTagComponent } from './podcast-tag/podcast-tag.component';
import { CustomTagComponent } from '@tytapp/app/custom-tag/custom-tag.component';
import { CommentsCountComponent } from './comments-count/comments-count.component';
import { VerticalCarouselComponent } from './vertical-carousel/vertical-carousel.component';
import { VerticalCarouselItemComponent } from './vertical-carousel-item/vertical-carousel-item.component';
import { TooltipButtonComponent } from './tooltip-button/tooltip-button.component';

const COMPONENTS = [
  ContentBadgeComponent,
  PlusTagComponent,
  PlusLockedComponent,
  PlusUnlockedComponent,
  FullEpisodeTagComponent,
  ArticleTagComponent,
  ClipTagComponent,
  PodcastTagComponent,
  CustomTagComponent,
  CommentsCountComponent,
  VerticalCarouselComponent,
  VerticalCarouselItemComponent,
  TooltipButtonComponent
]

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: COMPONENTS,
  exports: COMPONENTS
})
export class CommonUiModule { }
